import type { TFunction } from 'i18next';

const EXPORT_TRUNCATED_HEADER = 'x-openx-export-truncated';
const EXPORT_ROW_LIMIT_HEADER = 'x-openx-export-row-limit';

export type ExportTruncation = {
  rowLimit: string | null;
  truncated: boolean;
};

type HeaderGetter = { get: (name: string) => unknown };

const hasHeaderGetter = (headers: unknown): headers is HeaderGetter =>
  typeof (headers as Partial<HeaderGetter> | null | undefined)?.get === 'function';

/** Covers both `fetch` Headers and the two shapes axios can hand back, a plain record or AxiosHeaders. */
const readHeader = (headers: unknown, name: string): string | null => {
  const value = hasHeaderGetter(headers)
    ? headers.get(name)
    : (headers as Record<string, unknown> | null | undefined)?.[name];

  return typeof value === 'string' ? value : null;
};

/** Export endpoints cap how many rows land in one file and report the cap back through these headers. */
export const readExportTruncation = (headers: unknown): ExportTruncation => ({
  rowLimit: readHeader(headers, EXPORT_ROW_LIMIT_HEADER),
  truncated: readHeader(headers, EXPORT_TRUNCATED_HEADER) === 'true',
});

export const getExportTruncationWarning = (t: TFunction, objectType: string, rowLimit: string | null): string =>
  rowLimit
    ? t('More {objectType} match your filters than fit in one file. The first {limit} were exported.', {
        limit: rowLimit,
        objectType,
      })
    : t('More {objectType} match your filters than fit in one file. Not all of them were exported.', { objectType });
